// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xrSb","content":"styles_content__2jwj_"};